import { useEffect, useRef } from "react";

export function useDismiss<Anchor extends HTMLElement, Panel extends HTMLElement = HTMLElement>(
  open: boolean,
  close: () => void,
) {
  const anchor = useRef<Anchor>(null);
  const panel = useRef<Panel>(null);

  const latest = useRef(close);
  useEffect(() => {
    latest.current = close;
  });

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event: PointerEvent) => {
      const target = event.target as Node;
      if (anchor.current?.contains(target) === true) return;
      if (panel.current?.contains(target) === true) return;
      latest.current();
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") latest.current();
    };
    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown, true);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return { anchor, panel };
}
